import { screenWidth } from "utils/css";

export const isMobile = () => {
  var width = screenWidth()
  return width < 768
}